<template>
	<v-layout column fill-height v-bind='$attrs'>
		<slot :sortition="sortition">
			<v-flex>
				<div>
					<font-awesome-icon icon='clock' size='6x' />
				</div>
			</v-flex>
			<v-flex md3>
				<span class='font-weight-bold text-uppercase text-h4'>Next draw in</span>
			</v-flex>
			<v-flex md3 class='mt-3'>
				<span v-if='sortition.timeLeft' class='font-weight-black text-uppercase text-h3'>{{ sortition.timeLeft }}</span>
				<span v-else><font-awesome-icon icon='sync' spin size='3x'></font-awesome-icon></span>
			</v-flex>
		</slot>
	</v-layout>
</template>

<script>
export default {
	name: 'Countdown',
	props: {
		sortition: {
			type: Object,
			required: true
		}
	}

};
</script>

<style>
</style>
